
import { GambleCollectCommand } from "slotworks/commands/comms/gamble-collect-command";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Services } from "slotworks/services/services";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIFlags from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";

export default class Autoplay extends State {
    protected collecting: boolean = false;

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.IDLE, false);
        Services.autoplay.spin();
        this.collecting = false;

        const record: SpinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

        if (record.gamble) {
            this.collecting = true;
            GambleCollectCommand().then(() => {
                this.complete();
            });
        } else {
            this.complete();
        }
    }

    public onSkip() {
        if (!this.collecting) {
            const record: SpinRecord = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

            if (record.gamble) {
                this.collecting = true;
                GambleCollectCommand().then(() => {
                    this.skip();
                });
            } else {
                this.skip();
            }
        }
    }
}
